import React, {Component} from 'react';

import asyncComponent from './../hoc/asyncComponent/asyncComponent';
import AgencyMonitorDashboard from  "../../containers/AgencyMonitor/AgencyMoniorDashboard"
import TopNav from '../nav/TopNav';
import SideNav from '../nav/SideNav'
import BodyNav from '../nav/BodyNav'
import Home from "../home/Home";
import {Route, Switch, withRouter, Redirect} from 'react-router-dom';
import {NotFound} from "../../app/routes";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import * as AuthAction from "../../actions/AuthAction";
import loadingGIF from "../../public/assets/images/loading.gif";
import ConfirmModal from '../common/ConfirmModal';
import TableauView from "../tableau/Views";


const ManageUser = asyncComponent(() => {
    return import('../manageUser/ManageUser');
});

const AgencyProfile = asyncComponent(() => {
    return import('../manageUser/AgencyProfile');
});

const PLWorksheetPage = asyncComponent(() => {
    return import('../../containers/PLWorksheetPage');
});

const PeerEvaluationPage = asyncComponent( () => {
   return import('../../containers/PeerEvaluationContainer');
});

const JobDescriptionPage = asyncComponent(() => {
    return import('../../containers/JobDescriptionPage');
});

const KPIContainer = asyncComponent(() => {
    return import('../../containers/KPIContainer');
});

const CompensationContainer = asyncComponent(() => {
    return import('../../containers/CompensationContainer');
});

const StaffDataContainer = asyncComponent(() => {
    return import('../../containers/StaffDataContainer');
});

const StaffDashboardContainer = asyncComponent(() => {
    return import ("../../containers/StaffDashboardContainer");
});

const OrganicGrowthWizardContainer = asyncComponent(() => {
    return import ("../../containers/OrganicGrowthWizardContainer");
});

const ReportContainer = asyncComponent(() => {
    return import ("../../containers/ReportContainer");
});

const ComplianceAudit = asyncComponent(() => {
    return import ("../../containers/ComplianceAudit");
});

const AgencyMonitorAdmin = asyncComponent(() => {
  return import ("../../containers/AgencyMonitor/AgencyMonitorAdmin");
});

const KpiPlanning = asyncComponent(() => {
    return import ("../kpiPlanning/KpiPlanning");
});

const KnowledgeBase = asyncComponent(() => {
    return import ("../knowledgeBase/KnowledgeBase");
});

const ZendeskSupport = asyncComponent(() => {
    return import ("../common/Zendesk");
});

const PTO = asyncComponent(() => {
    return import ("../pto/PTO");
});

const ProducerCompensation = asyncComponent(() => {
    return import ("../producerCompensation/ProducerCompensation");
});

const AssignPermission = asyncComponent(() => {
    return import ("../manageUser/AssignPermission");
});


class Dashboard extends Component {
    state = {
        isLoading: false,
        showConfirmModal : false,
        model : {
            msgTitle : '',
            msgBody : '',
            buttons : []
        },
        fullSideBar: false,
        selectedMenu: 'Home',
        selectedSubMenu: ''
    }
    componentDidMount = () => {
        this.updateActiveMenu();
    }

    componentDidUpdate = (prevProps) => {
        if (this.props.agencyLocation !== prevProps.agencyLocation) {
            this.locationChanged();
        }
        
        if(prevProps.location.pathname !== this.props.location.pathname) {
            this.updateActiveMenu();
        } else if (prevProps.location.hash !== this.props.location.hash){
            this.updateActiveMenu();
        }
    }

    updateActiveMenu = () => {
        switch (this.props.location.pathname) {
            case '/user/profile': {
                return this.setActiveMenu('admin', 'manageUser');
            }
            case '/user-profile': {
                return this.setActiveMenu('admin', 'manageUser');
            }
            case '/agency/profile': {
                return this.setActiveMenu('admin', 'agencyProfile');
            }  
            case '/agency-profile': {
                return this.setActiveMenu('admin', 'agencyProfile');
            }  
            case '/agency-monitor': {
                return this.setActiveMenu('admin', 'agencyMonitor');
            } 
            case '/assign-permission': {
                return this.setActiveMenu('admin', 'assignPermission');
            }  
            case '/home': {
                return this.setActiveMenu('home', '');
            }  
            case '/pl/worksheet': {
                return this.setActiveMenu('resources', 'pl');
            }  
            case '/pl-worksheet': {
                return this.setActiveMenu('resources', 'pl');
            }  
            case '/peer-evaluation': {
                return this.setActiveMenu('resources', 'peerEval');
            }
            case '/peer-evaluation': {
                return this.setActiveMenu('resources', 'peerEval');
            }
            case '/kpi-planning': {
                return this.setActiveMenu('resources', 'kpiPlanning');
            }
            case '/pto': {
                return this.setActiveMenu('pto', '');
            }
            case '/organic-growth-wizard': {
                return this.setActiveMenu('ogw', '');
            }  
            case '/compliance-audit': {
                return this.setActiveMenu('compAudit', '');
            }
            case '/job/description': {
                return this.setActiveMenu('jobDesc', '');
            }
            case '/job-description': {
                return this.setActiveMenu('jobDesc', '');
            }
            case '/kpi': {
                return this.setActiveMenu('kpi', '');
            }
            case '/staff-data': {
                return this.setActiveMenu('staffData', '');
            }
            case '/compensation/profile': {
                return this.setActiveMenu('compProfile', '');
            }
            case '/compensation-profile': {
                return this.setActiveMenu('compProfile', '');
            }
            case '/producer-compensation': {
                return this.setActiveMenu('producerComp', '');
            }
          
            case '/reports/': {
                let hash = this.props.location.hash;
                switch(hash) {
                    case '#commission-report': {
                        return this.setActiveMenu('reports', 'commission-report');
                    }
                    case '#compensation-agreement': {
                        return this.setActiveMenu('reports', 'compensation-agreement');
                    }
                    case '#staff-data': {
                        return this.setActiveMenu('reports', 'staff-data');
                    }
                    case '#activity-report': {
                        return this.setActiveMenu('reports', 'activity-report');
                    }
                    case '#kpi-explanations': {
                        return this.setActiveMenu('reports', 'kpi-explanations');
                    }
                    case '#performance-evaluation': {
                        return this.setActiveMenu('reports', 'performance-evaluation');
                    }
                    case '#staff-timesheet': {
                        return this.setActiveMenu('reports', 'staff-timesheet');
                    }
                    default: {
                        return this.setActiveMenu('reports', 'kpi-explanations');
                    }
                }
            }
            default: {
                return this.setActiveMenu('', '');
            }
        }
    }

    setActiveMenu = (menu, subMenu) => {
        this.setState({
            selectedMenu: menu,
            selectedSubMenu: subMenu
        });
        return false;
    }

    locationChanged = () => {
        this.setState({isLoading: true, showLoader: true}, () => {
            this.setState({isLoading: false, showLoader: true});
        });
    };

    showConfirmModal = (modelObject) =>{
        const newModel = {};
        newModel.size = modelObject.size && modelObject.size.length ? modelObject.size : 'sm';
        newModel.msgTitle = modelObject.msgTitle && modelObject.msgTitle.length ? modelObject.msgTitle : '';
        newModel.msgBody = modelObject.msgBody && modelObject.msgBody.length ? modelObject.msgBody : '';
        newModel.buttons = modelObject.buttons && modelObject.buttons.length ? modelObject.buttons : [];
        this.setState({showConfirmModal: true, model: newModel});
    };

    hideConfirmModal = (event) => {
        const name = event.target.name;
        if (name === 'discard-model-btn') {
            this.setState({showConfirmModal: false, model: {}});
        }
    };

    clickNavBox = () => {
        this.setState({fullSideBar: false});
        return false;
    };

    toggleSideNav = () =>{
        this.setState((prevProps) => ({fullSideBar: !prevProps.fullSideBar}));
    }

    openSideBar = () => {
        this.setState({fullSideBar: true});
        return false;
    }

    render() {
        const {
            isLoading, model, showConfirmModal, fullSideBar, selectedMenu, selectedSubMenu
        } = this.state;
        let hash = window.location.hash.split('?')[0].toUpperCase();

        return (
            window.location.pathname!='/agency-monitor-staff' ?
            <div className="main-wrapper">
                <TopNav history={this.props.history} 
                    fullSideBar={fullSideBar} 
                    toggleSideNav={this.toggleSideNav}
                />
                <SideNav fullSideBar={fullSideBar} 
                    openSideBar={this.openSideBar}
                    selectedMenu={selectedMenu}
                    selectedSubMenu={selectedSubMenu}
                />
                <div className={`page-wrapper ${fullSideBar ? "full" : "mini"}`} 
                    onClick={this.clickNavBox}
                >
                    <BodyNav 
                        selectedMenu={selectedMenu}
                        selectedSubMenu={selectedSubMenu}
                    />
                    { showConfirmModal && 
                        <ConfirmModal {...model} 
                            showConfirmModal={showConfirmModal} 
                            hide={this.hideConfirmModal}
                        />
                    }
                    {isLoading ?
                        <img src={loadingGIF} alt="loading..." className="main-loading-gif" /> 
                        :
                        <React.Fragment>
                        <Switch>
                            <Route path='/agency-monitor-staff'
                                render={(props) => 
                                    <AgencyMonitorDashboard {...props} isStaff={true} />
                                }
                            />
                            <Route path='/user/profile'
                                render={(props) => {
                                    this.handleMenuChange('admin', 'manageUser');
                                    return <ManageUser {...props} 
                                        showConfirmModal ={this.showConfirmModal}
                                    />
                                }}
                            />
                            <Route path='/user-profile'
                                render={(props) => {
                                    return <ManageUser {...props} 
                                        showConfirmModal ={this.showConfirmModal}
                                    />
                                }}
                            />
                            <Route path='/agency/profile' 
                                render={(props) => {
                                    return <AgencyProfile {...props} 
                                        showConfirmModal ={this.showConfirmModal}
                                    />
                                }}
                            />
                            <Route path='/agency-profile' 
                                render={(props) => {
                                    return <AgencyProfile {...props} 
                                        showConfirmModal ={this.showConfirmModal}
                                    />
                                }}
                            />
                            <Route path='/assign-permission' 
                                render={(props) => {
                                    return <AssignPermission {...props} 
                                        showConfirmModal ={this.showConfirmModal}
                                    />
                                }}
                            />
                            <Route path='/pto' 
                                render={(props) => {
                                    return <PTO {...props} 
                                        showConfirmModal ={this.showConfirmModal}
                                    />
                                }}
                            />
                            <Route path='/agency-monitor' 
                                render={() => {
                                    return <AgencyMonitorAdmin /> 
                                }}
                            />
                            <Route path='/home'
                                render={(props) => {
                                    return <Home {...props} 
                                        showConfirmModal={this.showConfirmModal}
                                    />
                                }}
                            />
                            <Route path='/pl/worksheet' 
                                render={() => {
                                    return <PLWorksheetPage />
                                }}
                            />
                            <Route path='/pl-worksheet' 
                                render={() => {
                                    return <PLWorksheetPage />
                                }}
                            />
                            <Route path='/peer-evaluation'
                                render={(props) => {
                                    return <PeerEvaluationPage {...props} 
                                        showConfirmModal ={this.showConfirmModal}
                                    />
                                }}
                            />
                            <Route path='/organic-growth-wizard'
                                render={(props) => {
                                    return <OrganicGrowthWizardContainer {...props} 
                                        showConfirmModal ={this.showConfirmModal}
                                    />
                                }}
                            />
                            <Route path='/compliance-audit'
                                render={(props) => 
                                    <ComplianceAudit {...props} 
                                        showConfirmModal ={this.showConfirmModal}
                                    />
                                }
                            />
                            <Route path='/job/description' component={JobDescriptionPage}/>
                            <Route path='/job-description' component={JobDescriptionPage}/>
                            <Route path='/kpi' component={KPIContainer}/>
                            <Route path='/staff-data' component={StaffDataContainer} />
                            <Route path='/compensation/profile' 
                                render={(props) => 
                                    <CompensationContainer {...props} 
                                        showConfirmModal ={this.showConfirmModal}
                                    />
                                }
                            />
                            <Route path='/compensation-profile'
                                render={(props) => 
                                    <CompensationContainer {...props} 
                                        showConfirmModal ={this.showConfirmModal}
                                    />
                                }
                            />
                            
                            <Route path='/dashboard'
                                render={(props) => 
                                    <StaffDashboardContainer {...props} isStaff={false} />
                                }
                            />
                            <Route path='/reports' 
                                render={(props) => 
                                    <ReportContainer {...props} 
                                        showConfirmModal ={this.showConfirmModal}
                                    />
                                }
                            />
                            <Route path='/installation-wizard' 
                                render={() => <Redirect to="/home" />}
                            />
                            <Route path='/kpi-planning' component={KpiPlanning} />
                            <Route path='/knowledgebase' 
                                render={() => 
                                    <KnowledgeBase openModal={true} direct={true}/>
                                }
                            />
                            <Route path='/producer-compensation' 
                                render={(props) => {
                                    return <ProducerCompensation {...props} 
                                        showConfirmModal ={this.showConfirmModal}
                                    />
                                }}
                            />
                            <Route path='/tableau' component={TableauView} />
                            <Route path='/404' component={NotFound} />
                            <Route render={() => <Redirect to="/home" />} />
                        </Switch>
                        {hash === "#knowledgebase".toUpperCase() &&
                            <KnowledgeBase openModal={true} />
                        }
                        </React.Fragment>
                    }
                    <ZendeskSupport />
                </div>
            </div>
             : <div>
             <AgencyMonitorDashboard {...this.props} isStaff={true} />
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        agencyLocation: state.AgencyLocationReducer
    };
}

function mapDispatchToProps(dispatch) {
    return {
        authAction: bindActionCreators(AuthAction, dispatch)
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Dashboard));



// WEBPACK FOOTER //
// ./src/components/dashboard/Dashboard.js